<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicAccountData } from '@/composables/useEconomicAccountData';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
import { computed } from 'vue';
    
    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    defineProps<{
        form: any;
    }>();

    const { accounts } = useEconomicAccountData(companyId.value);
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="contra_account_id"
            label="viia.accounts.attach"
        >
            <Combobox
                v-model="form.contra_account_id"
                :options="accounts"
                :translate="false"
                :placeholder="$t('viia.accounts.attach')"
                :loading="false"
                label-by="number_and_name"
                value-by="accountNumber"
            />
        </InputRow>
    </div>
</template>
